<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/allocationIndex' }"
          >客户资源分配管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>客户详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="customer_wrap">
      <div class="customer_list">
        <div class="block flex-rowl">
          <p>
            客户名称：<span>{{
              customerDetail.info_truename
                ? customerDetail.info_truename
                : customerDetail.ext_name
            }}</span>
          </p>
          <p>
            企业名称：<span>{{ customerDetail.other_companystr }}</span>
          </p>
          <p>
            联系方式：<span>{{ customerDetail.info_mobile }}</span>
          </p>
          <p>
            客户标签：<span>{{ customerDetail.info_tag_idstr }}</span>
          </p>
          <p>
            补充分类：<span>{{ customerDetail.other_typestr }}</span>
          </p>
          <p>
            客户属性：<span>{{ customerDetail.other_attrstr }}</span>
          </p>
          <p>
            联系优先度：<span>{{ customerDetail.other_yxdstr }}</span>
          </p>
          <p>成交记录：<span></span></p>
        </div>
        <div class="block flex-rowl">
          <p>
            所在地区：<span v-if="customerDetail.other_provincename">{{
              customerDetail.other_provincename
            }}</span>
            <span v-if="customerDetail.other_cityname"
              >、{{ customerDetail.other_cityname }}</span
            >
            <span v-if="customerDetail.other_areaname"
              >、{{ customerDetail.other_areaname }}</span
            >
            <span v-if="customerDetail.other_address"
              >、{{ customerDetail.other_address }}</span
            >
          </p>
          <p>
            当前客户归属：<span>{{ customerDetail.info_remark }}</span>
          </p>
          <p>
            职务：<span>{{ customerDetail.other_job }}</span>
          </p>
          <p>
            最新触达日期：<span>{{ customerDetail.createdate }}</span>
          </p>
        </div>
      </div>
      <div class="btn_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="btn flex-rowl" @click="handleGo(1, 0)">
            <i class="iconfont icon-xinzeng"></i> 客户资源分配
          </p>
          <p class="btn flex-rowl" @click="handleGo(3)">
            <i class="iconfont icon-xinzeng"></i> 更新客户信息
          </p>
        </div>
      </div>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="分配记录" name="first">
        <!-- 主要内容 start -->
        <div class="main_container">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="dataListF.length > 0">
              <div
                class="item_wrap"
                v-for="(item, index) in dataListF"
                :key="index"
              >
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div
                      class="intro_box flex-rowl"
                    >
                      <div class="block">
                        <p class="red">
                          分配给：
                          <span>{{ item.cmuseropenidstr }}</span>
                        </p>
                        <p class="red">
                          分配日期：
                          <span>{{ item.createdate | formatDate }}</span>
                        </p>
                      </div>
                      <div class="block">
                        <p class="red">
                          操作人：
                          <span>{{ item.openidstr }}</span>
                        </p>
                        <p>
                          分配类型：
                          <span>{{ item.gettypestr }}</span>
                        </p>
                      </div>
                      <div class="block address_wrap">
                        <p>备注说明：</p>
                        <p>
                          <span>{{ item.details }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <el-empty description="暂无数据" v-else></el-empty>
          </div>
        </div>
        <!-- 主要内容 end -->
        <!-- 分页 start -->
        <div class="pagination_wrap flex-rowc">
          <el-pagination
            @current-change="handleCurrentChangeF"
            layout="prev, pager, next, jumper"
            :page-size="10"
            :total="listTotalF"
          >
          </el-pagination>
        </div>
        <!-- 分页 end -->
      </el-tab-pane>
      <el-tab-pane label="触达记录" name="second">
        <!-- 主要内容 start -->
        <div class="main_container">
          <div
            class="list_wrap"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <template v-if="dataListC.length > 0">
              <div
                class="item_wrap"
                v-for="(item, index) in dataListC"
                :key="index"
              >
                <div class="item_main_wrap flex-rowl">
                  <div class="content_wrap flex-between">
                    <div class="intro_box flex-rowl">
                      <div class="block">
                        <p class="red">
                          添加人：
                          <span>{{ item.customeridstr }}</span>
                        </p>
                        <p class="red">
                          触达日期：
                          <span>{{ item.createdate | formatDate }}</span>
                        </p>
                      </div>
                      <div class="block">
                        <p>
                          联系形式：
                          <span>{{ item.gettypestr }}</span>
                        </p>
                        <p>
                          最近联系情况：
                          <span>{{ item.getstatestr }}</span>
                        </p>
                        <p>
                          联系结果：
                          <span>{{ item.resultstr }}</span>
                        </p>
                      </div>
                      <div class="block address_wrap">
                        <p>情况说明：</p>
                        <p>
                          <span>{{ item.details }} </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <el-empty description="暂无数据" v-else></el-empty>
          </div>
        </div>
        <!-- 主要内容 end -->
        <!-- 分页 start -->
        <div class="pagination_wrap flex-rowc">
          <el-pagination
            @current-change="handleCurrentChangeC"
            layout="prev, pager, next, jumper"
            :page-size="10"
            :total="listTotalC"
          >
          </el-pagination>
        </div>
        <!-- 分页 end -->
      </el-tab-pane>
    </el-tabs>

    <!-- <div class="form_footer flex-rowl">
      <div class="btn" @click="handleGo(1)">客户资源分配</div>
      <div class="btn" @click="handleGo(3)">更新客户信息</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div> -->
  </div>
</template>

<script>
import {
  getCustomerGenList,
  getCustomerDisList,
  getCustomerDetail,
  encryptstringview,
  encryptstringadd,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "rAllocationDetail",
  data() {
    return {
      id: "",
      activeName: "first",
      loading: false,

      // 触达记录
      paramsC: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        customerid: "",
      },
      listTotalC: 0,
      dataListC: [],

      // 分配记录
      paramsF: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        customerid: "",
      },
      listTotalF: 0,
      dataListF: [],
      customerDetail: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
    // this.getCustomerGenList();
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.paramsC.customerid = id;
        this.paramsF.customerid = id;
        this.id = id;
        this.getCustomerDisList();
        this.getCustomerDetail();
      } else {
        this.$router.back();
      }
    },

    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.customerDetail = res;
      });
    },

    // 获取触达记录数据
    getCustomerGenList() {
      this.loading = true;
      getCustomerGenList(this.paramsC).then((res) => {
        this.dataListC = res.list;
        this.listTotalC = res.total;
        this.loading = false;
      });
    },
    // 触达记录分页
    handleCurrentChangeC(e) {
      this.paramsC.pageindex = e;
      this.getCustomerGenList();
    },

    // 获取分配记录
    getCustomerDisList() {
      this.loading = true;
      getCustomerDisList(this.paramsF).then((res) => {
        this.dataListF = res.list;
        this.listTotalF = res.total;
        this.loading = false;
      });
    },

    // 分配记录分页
    handleCurrentChangeF(e) {
      this.paramsF.pageindex = e;
      this.getCustomerDisList();
    },

    handleClick() {
      if (this.activeName == "first") {
        this.getCustomerDisList();
      } else if (this.activeName == "second") {
        this.getCustomerGenList();
      }
    },
    handleReturn() {
      this.$router.back();
    },
    handleGo(type, id) {
      if (type == 1) {
        // this.$router.push(
        //   `/resourceIndex/rAllocationCustomer/${this.id}/${id}`
        // );
        this.encryptstringadd("rAllocationCustomer", { id: this.id, idC: id });
      } else if (type == 2) {
        // this.$router.push(`/resourceIndex/rServiceAddRecord/${this.id}/${id}`);
        this.encryptstringadd("rServiceAddRecord", { id: this.id, idC: id });
      } else if (type == 3) {
        // this.$router.push(`/resourceIndex/updateCustomer/${this.id}/2`);
        this.encryptstringadd("updateCustomer", { id: this.id, type: 2 });
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .operation_wrap {
    p {
      &:nth-child(2) {
        margin: 0 15px;
        box-sizing: border-box;
      }
    }
  }
  .customer_wrap {
    font-size: 16px;
    color: #404d6c;
    padding: 15px 0 0;
    .block {
      margin-bottom: 10px;
      font-size: 14px;
      h1 {
        font-size: 18px;
        color: #444444;
        margin-top: 10px;
      }
    }
    p {
      margin-right: 20px;
    }
    .btn_wrap {
      margin: 10px 0 5px;
      .btn {
        border: 1px solid #6b5e84;
        padding: 4px 15px;
        border-radius: 45px;
        margin-right: 20px;
        font-size: 14px;
        cursor: pointer;
        .iconfont {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }
  .main_container {
    .list_wrap {
      height: 45vh;
      .intro_box {
        cursor: pointer;
      }
      .red {
        color: #ff0036;
      }
    }
  }
  .form_footer {
    .btn {
      margin-right: 30px;
    }
  }
}
</style>